module.exports = {
  reducers: require("./reducers"),
  workspaceDevReducer: require("./reducers/workspaces/dev"),
  listeners: require("./listeners"),
  StoreManager: require("./storeManager"),
  browserStorage: require("./browserStorage")
}
